import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"dossier"} maskId="square-filled-radius-0-stroke-1-IconDossier"><path d="M2 4H8V9H22V20H2V4Z" fill="currentColor"/><path d="M9 4H15V8H9V4Z" fill="currentColor"/><path d="M16 4H22V8H16V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDossier;
